export default {
  count: 10,
  name: 'John',
  userInfo: {}, // 用户信息
  activityInfo: {}, // 活动信息
  promotionList: {}, // 促销信息
  couponList: {}, // 优惠券信息
  beltList: [], // 腰带信息
  applyGiftMaterialList: {}, // 店铺礼包信息
  contentVenderLabelList: {}, // 店铺热文
  productList: {}, // 广告信息,
  applyId: {},
  baseUrl: '//z.shop.jd.com',
  baseDevUrl: '//z.shop.jd.com',
  langFlag: 0,
  marketSearchObj: {
    activityId: '',
    activityName: '',
    activityType: '',
    activityStatus: '',
    pageNo: 1,
    pageSize: 10,
    activeType: '' // 当前活动的tab
  },
  activitySearchObj: {
    activityId: '',
    activityName: '',
    activityType: '',
    activityStatus: '',
    pageNo: 1,
    pageSize: 10,
    activeType: '' // 当前活动的tab
  },
  inviteShopList: [],
  inMicroApp: !!window.__MICRO_APP_ENVIRONMENT__ || window.top !== window || false // 是否在基座环境
}



// WEBPACK FOOTER //
// ./src/store/state.js